/**************************************************************************************************************************************************
*   MODULE NAME     :  ExportToPDF
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  27-04-2021
*   DESCRIPTION     :  Export To PDF
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as strs64 from '../../assets/NotoSans64';
import { ddmmmyyyyFormat } from "../common/DateFormat";
const exportToPDF = (heading, title, headers, data, widths, textStr) => {
}
export const exportPDF = (heading, title, headers, data, widths, textStr) => {
  var imageStr64 = strs64.STR_LILLY_LOGO;
  imageStr64 = 'data:image/jpeg;base64,' + imageStr64;
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  pdfMake.vfs["Noto.ttf"] = strs64.STR_NOTO_SANS;
  pdfMake.fonts = {
    NotoSans: {
      normal: 'Noto.ttf',
      bold: 'Noto.ttf',
      italics: 'Noto.ttf',
      bolditalics: 'Noto.ttf'
    }
  }
  var notFoundStr = "";
  if (data.length === 0) {
    notFoundStr = "No Records Found"
  }
  var url = window.location.href;
  if (heading.includes("Metric") || heading.includes("Dash")) {
    url = ""
  }
  var docDefinition = {
    info: {
      title: heading.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).join('_') + "_" + Date.now()
    },
    pageOrientation: 'landscape',
    pageMargins: [10, 100, 10, 40],
    header: function (currentPage, pageCount) {
      return [
        {
          columnGap: 10,
          margin: [10, 0],
          columns: [
            {
              image: imageStr64,
              width: 110,
              height: 68,
            },
            {
              margin: [4, 18],
              text: ' |   GLSD', alignment: 'left',
              style: { fontSize: 25, bold: true, color: 'black' }
            },            
            {
              margin: [10, 5],
              text: 'Page '+currentPage.toString() + ' of ' + pageCount, alignment: 'right'
            }
          ]
        },
        { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 5195, y2: 0, lineWidth: 1 }] },
        {
          text: heading, alignment: 'left', margin: [10, 4],
          style: { fontSize: 13, bold: true, color: 'black' }
        },
        {
          text: title, alignment: 'left', margin: [10, 0],
          style: { fontSize: 9, bold: true, color: 'black' }
        }
      ]
    },
    footer: function (currentPage, pageCount) {
      return [
        {
          margin: [10, 0, 10, 0],
          columns: [
            { text: " GLSD ( Global Literature Screening Database ) ", style: { fontSize: 10 } },
            { text: ' Eli Lilly and Company Confidential', style: { bold: true, alignment: 'center', color: 'red', fontSize: 14, margin: [10, 10, 10, 10] } },
            { text: ddmmmyyyyFormat(new Date(), true), style: { alignment: 'right', fontSize: 10, margin: [10, 10, 10, 10] } },
          ]
        },
        {
          margin: [10, 0, 10, 0],
          columns: [
            { text: url, style: { alignment: 'right', fontSize: 10, margin: [10, 10, 10, 10] } },
          ]
        }
      ];
    },
    styles: {
      header: {
        fontSize: 9,
        bold: true,
        margin: [0, 0, 0, 10]
      },
      tableExample: {
        margin: [1, 5, 1, 15]
      },
    },
    content: [
      { text: textStr, margin: [0, 5] },
      {
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return (rowIndex === 0 ? '#c6b9ae' : (rowIndex % 2 === 0 ? '#dee3e3' : '#eaefef'));
          }
        },
        table: {
          headerRows: 1,
          widths: [...widths],
          body: [
            ...headers, ...data
          ]
        }
      },
      {
        margin: [10, 0, 10, 0],
        columns: [
          { text: "", style: { fontSize: 10 } },
          { text: notFoundStr, style: { alignment: 'center', fontSize: 10, margin: [10, 10, 10, 10] } },
          { text: "" },
        ]
      },
    ],
    defaultStyle: {
      font: 'NotoSans',
      fontSize: 7,
      bold: false
    }
  }
  pdfMake.createPdf(docDefinition).print();
}
export default exportToPDF;

